<template>
    <div v-if="docsLoaded">
        <hr/>
        <div v-if="error" class="error-container">
			<h2 class="error-heading">
				<i class="fa fa-exclamation-circle"></i> Whoops!
				<!-- <span>Please correct the following errors:</span> -->
			</h2>
			<ul>
				<li><i class="fa fa-exclamation"></i>{{ error }}</li>
			</ul>
		</div>
        <div v-else>
            <section v-if="generalEmailSent" class="message-container">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <ul class="list-unstyled">
                                <li class="message-head"><h2><i class="fa fa-info-circle"></i> Notice:</h2></li>
                                <li class="message-content">Email Sent</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <div class="form-group">
                <general-upload-table
                    :sendOfferingInvestorsUpdateDocsEmail="sendOfferingInvestorsUpdateDocsEmail"
                    :sendCompanyInvestorsUpdateDocsEmail="sendCompanyInvestorsUpdateDocsEmail"
                    :offering="offering"
                    :generalDocs="generalDocs"
                    :activeEmd="activeEmd"
                    :willDisplayGeneralSentEmailButton="willDisplayGeneralSentEmailButton"
                    :toggleGeneralEmailSendButton="toggleGeneralEmailSendButton"
                    :getGeneralDocument="getGeneralDocument"
                />
            </div>
            <br />
            <hr />
            <div class="form-group">
                <personalize-upload-table
                    :personalDocs="personalDocs"
                    :investmentsOptions="investmentsOptions"
                    :offering="offering"
                    :activeEmd="activeEmd"
                    :fileUploaded="addPersonalDoc"
                    :deletePersonalDoc="deletePersonalDoc"
                    :sendPersonalUpdateEmails="sendPersonalUpdateEmails"
                    :getPersonalDocument="getPersonalDocument"
                />
            </div>
        </div>
    </div>
    <div class="text-center" v-else>
        <img src="../../images/loader.gif" height="100px" width="100px" />
        <p>Please wait ... </p>
    </div>
</template>

<script>
import axios from 'axios';
import FileUploader from '../components/FileUploader.vue';
import PersonalizeUploadTable from '../components/offering/PersonalizeUploadTable'
import GeneralUploadTable from '../components/offering/GeneralUploadTable'

export default {
    data() {
        return {
            personalDocs: [],
            generalDocs: {
                data: [],
            },
            offering: window.offering,
            activeEmd: window.activeEmd,
            offeringInvestments: {},
            selectedInvestments: [],
            docsLoaded: false,
            error: null,
            generalEmailSent: false,
            willDisplayGeneralSentEmailButton: true,
        }
    },
    computed: {
        investmentsOptions() {
            const groupedPersonalDocuments = this.personalDocs.reduce(function(acc, doc) {
                let docsForCurrentTag = [];
                const { investment_id: investmentId, tag } = doc;

                const existingInvestmentId = Object.keys(acc).find(currentInvestmentId => Number(currentInvestmentId) === investmentId);
                if(!existingInvestmentId)
                    docsForCurrentTag = [doc]
                else {
                    const existingTag = Object.keys(acc[existingInvestmentId]).find(currentTag => currentTag === tag);
                    if(!existingTag)
                        docsForCurrentTag = [doc]
                    else
                        docsForCurrentTag = [doc, ...acc[investmentId][existingTag]];
                }
                return {
                    ...acc,
                    [investmentId]: {
                        ...(acc[investmentId] || {}),
                        [tag]: docsForCurrentTag
                    }
                }
            }, {});

            const investments = (this.offeringInvestments.data || [])
                .filter(investment => investment.status === 'complete' || investment.status === 'counter signed')
                .map(investment => {
                return {
                    id: investment.id,
                    investmentId: investment.id,
                    userId: investment.user_id,
                    name: `${investment.subscriber_name}`,
                    status: investment.status,
                    closedOn: investment.closed_on,
                    amount: investment.amount,
                    documents: groupedPersonalDocuments && groupedPersonalDocuments[investment.id] || {},
                }
            })

            return {
                ...this.offeringInvestments,
                data: investments
            }
        },
    },
    mounted() {
       this.loadData();
    },
    methods: {
        addPersonalDoc(doc) {
            this.personalDocs.push(doc);
        },
        deletePersonalDoc(id) {
            this.personalDocs = this.personalDocs.filter(doc => doc.id !== id);
        },
        sendPersonalUpdateEmails(investmentIds) {
            this.generalEmailSent = false
            const sendPersonalUpdateUrl = `/admin/${this.activeEmd.slug}/offerings/${this.offering.id}/docs/send_personal_email`
            const data = {
                investmentIds
            }
            return axios.post(sendPersonalUpdateUrl, data)
                .then(_response => {
                    this.generalEmailSent = true
                    return true
                })
                .catch(error => {
                    this.error = error;
                    return false
                });
        },
        sendOfferingInvestorsUpdateDocsEmail() {
            this.sendUpdateDocsEmail('/docs/send_offering_investors_update_email');
        },

        sendCompanyInvestorsUpdateDocsEmail() {
            this.sendUpdateDocsEmail('/docs/send_company_investors_update_email');
        },
        sendUpdateDocsEmail(url) {
            this.generalEmailSent = false;
            const sendUpdateUrl = `/admin/${this.activeEmd.slug}/offerings/${this.offering.id}${url}`;
            console.log('sendUpdateUrl', sendUpdateUrl);

            return axios.post(sendUpdateUrl)
                .then(_response => {
                    this.generalEmailSent = true;
                    this.willDisplayGeneralSentEmailButton = false;
                    return true;
                })
                .catch(error => {
                    this.error = error;
                    return false;
                });
        },
        toggleGeneralEmailSendButton(willDisplayButton) {
            this.willDisplayGeneralSentEmailButton = willDisplayButton
        },
        loadData() {
            Promise.all([this.getGeneralDocument(), this.getPersonalDocument()])
                .then(() => {
                    this.docsLoaded = true;
                })
                .catch(error => {
                    this.error = error;
                    this.docsLoaded = true
                });
        },
        async getPersonalDocument(page = 1) {
            const updateDocsUrl = `/admin/${this.activeEmd.slug}/offerings/${this.offering.id}/personal_documents?page=${page}`
            axios.get(updateDocsUrl)
                .then(response => {
                    const responseData = response.data
                    this.offeringInvestments = responseData.offeringInvestments
                    this.personalDocs = responseData.personalDocs
                    return responseData
                })
                .catch(error => {
                    this.error = error;
                    this.docsLoaded = true
                });
        },
        async getGeneralDocument(page = 1) {
            const updateDocsUrl = `/admin/${this.activeEmd.slug}/offerings/${this.offering.id}/general_documents?page=${page}`
            axios.get(updateDocsUrl)
                .then(response => {
                    const responseData = response.data
                    this.generalDocs = responseData.generalDocs
                    return responseData
                })
                .catch(error => {
                    this.error = error;
                });
        },
    },
    components: {
        FileUploader,
        PersonalizeUploadTable,
        GeneralUploadTable,
    }
}
</script>